import { WaitroseLogoSvg } from "./utils/WaitroseLogoSvg";
import styles from "./ClickAndCollectPreCountdownMessage.module.scss";

type Props = {
  /**
   * A string representing the collect from local time tomorrow
   */
  collectFromLocalTimeTomorrow: string;
};

export const ClickAndCollectPreCountdownMessageUI = ({
  collectFromLocalTimeTomorrow,
}: Props) => {
  return (
    <div
      className={styles.container}
      data-testid="pre-countdown-message"
      data-component="ClickAndCollectPreCountdown"
    >
      <WaitroseLogoSvg />
      <p className={styles.message} data-testid="pre-countdown-message-text">
        Collect from your nearest Waitrose from {collectFromLocalTimeTomorrow}{" "}
        tomorrow
      </p>
    </div>
  );
};
